export default __webpack_public_path__ + "418e0decb06026bdc3ef60921e309255.svg";